import { Tabs } from "djinn-components";
import { useSiteState } from "../../utils/useSiteState";
import FormHolder from "../../components/Form/FormHolder";
import ProjectDetailsForm from "../../components/Forms/ProjectEdit/Content";
import ProjectEditLinksForm from "../../components/Forms/ProjectEdit/Links";
import FAQsEditForm from "../../components/Forms/ProjectEdit/FAQs";
import SiteEditSidebar from "../../components/Sidebars/SiteEdit";

export default function EditSiteScreen() {
  const { site } = useSiteState();
  return (
    <>
      <title>Edit {site.title}</title>
      <div className="flex items-start justify-between w-full text-white">
        <div className="w-3/4 h-screen overflow-auto">
          <FormHolder>
            <Tabs
              defaultActive={0}
              tabs={[
                {
                  title: "Content",
                  component: <ProjectDetailsForm />,
                },
                {
                  title: "Store Links",
                  component: <ProjectEditLinksForm />,
                },
                {
                  title: "FAQs",
                  component: <FAQsEditForm />,
                },
              ]}
            />
          </FormHolder>
        </div>

        <div className="w-1/4 bg-gray-750 shadow-lg p-10 h-screen overflow-hidden sticky top-0 right-0">
          <SiteEditSidebar />
        </div>
      </div>
    </>
  );
}
